module.exports = "./img/d1f94d7d6fdcb938d4035d7b0e550c22.png";